<template>
  <div>课表管理</div>
</template>

<script>
export default {

}
</script>
